import React from "react";
import classNames from "classnames/bind";

import TutorialImg from "../../images/tutorial.png";
import {Button} from "../Button";

import styles from "./Tutorial.module.css";

const cx = classNames.bind(styles);

type Props = {
  onHide: () => void;
};

export const Tutorial: React.FC<Props> = ({onHide}) => {
  return (
    <div className={cx("overlay")}>
      <div></div>
      <img className={cx('overlay"__image')} src={TutorialImg} alt={'tutorial'}/>
      <div className={cx("overlay__content")}>
        <div className={cx("overlay__info")}>
          <p className={cx("overlay__text")}>Подсказка:</p>
          <p className={cx("overlay__text")}>
            Смахните вправо, если употребляете это блюдо в пищу.
          </p>
          <p className={cx("overlay__text")}>
            Смахните влево, если не употребляете никогда или реже 1 раза в год.
          </p>
        </div>
        <div className={cx("overlay__button")}>
          <Button
            onClick={onHide}
            color="cerulean"
            block
            size="medium"
            rounded
            type="button"
          >
            Понятно
          </Button>
        </div>
      </div>
    </div>
  );
};
